import React from "react";
import { Label, Button } from "reactstrap";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { undoPostponePayment } from "./AccountAPI";
import { useUserBhphPrivileges } from "../features/settings/subFeatures/settingsTabs/userManagement/useUserPrivileges";

const AcctAmortStatus = ({ amort, acct }) => {
	const privileges = useUserBhphPrivileges();
	const p = privileges();

	const handleUndo = () => {
		Swal.fire({
			title: "Undo Postponement?",
			text: `Do you want to undo the postponement for ${dayjs(amort.dueDate).format("MM/DD/YYYY")}?`,
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes, undo it!",
		}).then((result) => {
			if (result.isConfirmed) {
				undoPostponePayment(amort.id).then(
					() => {
						Swal.fire("Success!", "Postponement has been undone.", "success");
						window.location.reload();
					},
					(error) => {
						Swal.fire("Error!", "Failed to undo postponement.", "error");
					}
				);
			}
		});
	};
	// Compute how much is still owed:
	let balance =
		amort.int2Pay +
		amort.princ2Pay +
		(amort.salesTax || 0.0) -
		(amort.intPaid || 0.0) -
		(amort.princPaid || 0.0) -
		(amort.salesTaxPaid || 0.0);
	balance = parseFloat(balance).toFixed(2);
	balance = parseFloat(balance);
	// Remaining principal-only balance:
	const prnBalance = parseFloat(
		parseFloat(amort.princ2Pay - (amort.princPaid || 0)).toFixed(2)
	);

	// Parse both dates into timestamps for accurate comparison:
	const dueTs = amort.dueDate ? new Date(amort.dueDate).getTime() : null;
	const nextTs = acct.nextDueDate ? new Date(acct.nextDueDate).getTime() : null;

	amort.isDeferred === false;

	return (
		<>
			{
				// 1) If already deferred - show Postponed button
				amort.isDeferred ? (
					<Button
						color="info"
						size="sm"
						disabled={!p.postponePayment}
						onClick={handleUndo}
					>
						Postponed
					</Button>
				) :
				// 2) If fully paid
				balance === 0.0 ? (
					<Label style={{ color: "green", fontSize: "14px" }}>
						<h6>Full Paid</h6>
					</Label>
				) :
				// 3) If paid off principal early (no principal left but some interest/tax remains)
				prnBalance === 0 && balance > 0 ? (
					<Label style={{ color: "green", fontSize: "14px" }}>
						<h6>Paid Early</h6>
					</Label>
				) :
				// 4) If this is the next due date
				dueTs !== null && nextTs !== null && dueTs === nextTs ? (
					<h6>Next Due Date</h6>
				) :
				// 5) If past due
				prnBalance > 0 && dueTs !== null && nextTs !== null && dueTs < nextTs ? (
					<Label style={{ color: "red", fontSize: "14px" }}>
						<h6>Past Due</h6>
					</Label>
				) :
				// 6) Future scheduled payment
				null
			}
		</>
	);
};

export default AcctAmortStatus;
